import React, { useContext, useEffect, useState } from 'react';

import {
  Grid,
  IconButton,  
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  AddCircle,
  Image,
  InsertChart,  
  InsertChartOutlinedTwoTone
} from '@material-ui/icons';



import {
  useHistory,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

// import BasicButton from '../../buttons/basicButton';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import CustomAreaChart from '../../charts/customAreaChart';
import CustomBarChart from '../../charts/customBarChart';
import CustomLineChart from '../../charts/customLineChart';
import MenuDrawerTechnical from '../../fields/menuDrawerTechnical';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getBasicStats } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function Dashboard({ lang, handleChangeLang }) {
  const classesProva = useStyles();  
  const sessionContext = useContext(SessionContext);
  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();
  
  const [dataStatistics, setDataStatistics] = useState([]);
  const [dataStatisticsDetailed, setDataStatisticsDetailed] = useState([]);

  const [ready, setReady] = useState(false);

  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showGraphics, setShowGraphics] = useState([]);

  const history = useHistory();

  const getDetailedInfo = (data) => {
    const details = data.map((monthInfo) => {
      const infoByMonthArray = monthInfo.programs.map((programInfo) => {
        return {program: programInfo.program, totalMonth: programInfo.totalMonth};
      });
      // Passam l'array d'objectes a un unic objecte format pels noms de programa i valors de l'array anterior
      const infoByMonthMapped = infoByMonthArray.map(item => ({ [item.program]: item.totalMonth }) );
      const infoByMonth = Object.assign({}, ...infoByMonthMapped);
      // Afegim la propietat data i retornam l'objecte
      return Object.assign(infoByMonth, {date: monthInfo.date});
    });
    return details;
  }

  const formatDetailedStatistics = (statistics) => {    
    const numEnrolledPatientsArray = getDetailedInfo(statistics['numPacientsEnrolats']);
    const numPatientsFollowUpArray = getDetailedInfo(statistics['numPacientsEnSeguiment']);
    return {numPacientsEnrolats: numEnrolledPatientsArray, numPacientsEnSeguiment: numPatientsFollowUpArray};
  }
  
  useEffect(() => {
    const getBasicStatsFromServer = async () => {
      setShowLoading(true);
      const response = await getBasicStats(sessionContext.userToken);
      setShowLoading(false);
      if (response.status === 200) { // Tenim llistat        
        setDataStatistics(response.data.statistics);
        const responseDetailed = formatDetailedStatistics(response.data.statistics);
        setDataStatisticsDetailed(responseDetailed);        
        setReady(true);            
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    getBasicStatsFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  const gotoScreen = (screen) => {
    history.push(`/technical/${screen}`);
  };
  
  // Indica si la grafica s'ha de mostrar o no
  const showMe = (graphic) => {
    const show = showGraphics.includes(graphic);
    return show;
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  // Mostra o oculta una grafica
  const toggleGraphic = (graphic) => {
    const updatedGraphics = showGraphics.slice();
    // Miram si dins showGraphics hi ha el nom de la gràfica
    const idx = updatedGraphics.findIndex((item) => item == graphic);
    if (idx < 0) { // Si no hi és l'afegim
      updatedGraphics.push(graphic);
    } else { // Si hi és la llevam
      updatedGraphics.splice(idx, 1);
    }
    setShowGraphics(updatedGraphics);     
  };

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawerTechnical type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            {/* <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} /> */}
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          {/* <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_statsDashboard']}</Typography>
              </Grid>
            </Grid>
          </Grid> */}
          {/* ----------------------- Fila ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>                
                {/*<Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsGlobal']}<IconButton onClick={() => gotoScreen('detailed')}><AddCircle fontSize='large'/></IconButton><IconButton onClick={() => toggleGraphic('numPacientsActius')}>{showMe('numPacientsActius') ? <InsertChart fontSize='large'/> : <InsertChartOutlinedTwoTone fontSize='large'/>}</IconButton></Typography>*/}
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsGlobal']}{/*<IconButton onClick={() => gotoScreen('detailed')}><AddCircle fontSize='large'/></IconButton>*/}<IconButton onClick={() => toggleGraphic('numPacientsEnrolatsPerMes')}>{showMe('numPacientsEnrolatsPerMes') ? <InsertChart fontSize='large'/> : <InsertChartOutlinedTwoTone fontSize='large'/>}</IconButton></Typography>
                <Typography variant='body1' component='div'>{translations['_numEnrolledPatientsGlobalDesc']}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>
              <Grid item xs={10}>                
                {ready && <CustomAreaChart data={dataStatistics['numPacientsEnrolats']} areaDataKey={'accumulated'}/>}
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}          
          {showMe('numPacientsEnrolatsPerMes') && (
            <React.Fragment>
              <Grid item className={sectionTitleStyle.root}>
                <Grid container justify='space-between' spacing={2}>
                  <Grid item>                
                    <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsGlobalByMonth']}</Typography>
                    <Typography variant='body1' component='div'>{translations['_numEnrolledPatientsGlobalByMonthDesc']}</Typography> 
                  </Grid>
                </Grid>
              </Grid>         
              <Grid item>
                <Grid container justify='center' spacing={2}>
                  <Grid item xs={10}>
                    {ready && <CustomBarChart data={dataStatistics['numPacientsEnrolats']} dataKey='totalMonth'/>}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={sectionTitleStyle.root}>
                <Grid container justify='space-between' spacing={2}>
                  <Grid item>                
                    <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsDetailedByMonth']}</Typography>
                    <Typography variant='body1' component='div'>{translations['_numEnrolledPatientsDetailedByMonthDesc']}</Typography> 
                  </Grid>
                </Grid>
              </Grid>         
              <Grid item>
                <Grid container justify='center' spacing={2}>
                  <Grid item xs={10}>
                    {ready && <CustomBarChart data={dataStatisticsDetailed['numPacientsEnrolats']} big={true} />}
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          )}
          {/* ----------------------- Fila ----------------------- */}          
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>                
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numPatientsFollowUp']}{/*<IconButton onClick={() => gotoScreen('detailed')}><AddCircle fontSize='large'/></IconButton><IconButton onClick={() => toggleGraphic('numPacientsEnrolatsDetailed')}>{showMe('numPacientsEnrolatsDetailed') ? <InsertChart fontSize='large'/> : <InsertChartOutlinedTwoTone fontSize='large'/>}</IconButton> */}</Typography>
                <Typography variant='body1' component='div'>{translations['_numPatientsFollowUpDesc']}</Typography> 
              </Grid>
            </Grid>
          </Grid>          
          {/* ----------------------- Fila ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>
              <Grid item xs={10}>                
                {ready && <CustomAreaChart data={dataStatistics['numPacientsEnSeguiment']} areaDataKey={'totalMonth'}/>}
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}          
          {showMe('numPacientsEnrolatsDetailed') && (
            <React.Fragment>
              <Grid item className={sectionTitleStyle.root}>
                <Grid container justify='space-between' spacing={2}>
                  <Grid item>                
                    <Typography variant='h4' component='div' className={sectionTitleStyle.title}>** Número pacients Enrolats detallat **</Typography>
                    <Typography variant='body1' component='div'>** DESCRIPCIÓ Número pacients Enrolats detallat **</Typography> 
                  </Grid>
                </Grid>
              </Grid>         
              <Grid item>
                <Grid container justify='center' spacing={2}>
                  <Grid item xs={10}>
                    {/*<Typography variant='h5' component='div'>{translations['_numPatientsFollowUp']}</Typography>
                    <Typography variant='body1' component='div'>{translations['_numPatientsFollowUpDesc']}</Typography> */}
                    {ready && <CustomLineChart data={dataStatisticsDetailed['numPacientsEnrolatsDetailed']} />}
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          )}
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(Dashboard);

// Indica i controla els props que se han de passar al component
Dashboard.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};
